import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import TouchMenuItem from '../desktop-menu-item/TouchMenuItem';
import DesktopMenuItem from '../desktop-menu-item/DesktopMenuItem';
import FlyoutMenu from '../flyout-menu/FlyoutMenu';
import styles from './DesktopMenu.scss';
import { isTouchDevice } from '../../../utils/device/identifyDevice';

const DesktopMenu = ({ child }) => {
  const filteredChild = child?.filter(
    item => item.isDisplayedInGlobalNav !== false
  );

  const [activeIndex, setActiveIndex] = useState(-1);

  const MenuItem =
    typeof window !== 'undefined' && isTouchDevice()
      ? TouchMenuItem
      : DesktopMenuItem;

  const overlayClassName = classNames(styles.desktopMenuOverlay, {
    [styles.desktopMenuOverlay__active]: activeIndex !== -1,
  });

  return (
    <nav className={styles.desktopMenu} data-testid="navigation-menu">
      <ul className={styles.desktopMenuList}>
        {filteredChild.map((item, index) => {
          const { id, name, url, child: childItems } = item;
          return (
            <MenuItem
              key={name}
              label={name}
              url={url}
              active={activeIndex === index}
              onSelect={() => setActiveIndex(index)}
              onClose={() => setActiveIndex(-1)}
            >
              {childItems?.length > 0 && (
                <FlyoutMenu id={id} columns={childItems} hierarchy={name} />
              )}
            </MenuItem>
          );
        })}
      </ul>
      <div className={overlayClassName} data-testid="desktop-menu-overlay" />
    </nav>
  );
};

const itemShape = {
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  url: PropTypes.string,
};
itemShape.child = PropTypes.arrayOf(PropTypes.shape(itemShape));

DesktopMenu.propTypes = {
  child: PropTypes.arrayOf(PropTypes.shape(itemShape)).isRequired,
};

export default DesktopMenu;
